export default "__VITE_ASSET__x8cuxwIt__"